import React from 'react'
import { connect } from '@cerebral/react'
import { signal } from 'cerebral/tags'

export default connect(
  {
    closeNode: signal`node.closeNode`
  },
  ({ closeNode }) => {
    return (
      <div
        onClick={e => closeNode()}
        style={{
          alignSelf: 'center',
          marginRight: 15
        }}
      >
        <svg
          style={{ cursor: 'pointer' }}
          onClick={e => {}}
          fill={'rgba(0,0,0,0.57)'}
          height={20}
          viewBox={'0 0 24 24'}
          width={20}
        >
          <path
            d={
              'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
            }
          />
          <path d={'M0 0h24v24H0z'} fill={'none'} />
        </svg>
      </div>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/Node/close.js